// Phase 79 — Resolve photo URLs for both legacy base64 and new object-storage paths.
// Profile photos served via /api/files/{path} need a JWT — pass it via ?token= query
// since <img src> cannot send Authorization headers.
import { BACKEND_URL } from './api';

export function resolvePhotoUrl(input) {
  if (!input) return null;
  // Legacy base64 data-URL → use as-is
  if (typeof input === 'string' && input.startsWith('data:')) return input;
  // Full URL → use as-is
  if (typeof input === 'string' && /^https?:\/\//.test(input)) return input;
  // API-relative path (e.g. "/api/files/outplay/{aid}/profile-photos/...png")
  const token = localStorage.getItem('outplay_token');
  const sep = input.includes('?') ? '&' : '?';
  return `${BACKEND_URL}${input}${sep}token=${encodeURIComponent(token || '')}`;
}

// Convenience: extract the most-recent photo URL from a profile-like object.
export function bestPhotoFor(obj) {
  if (!obj) return null;
  return resolvePhotoUrl(
    obj.profile_photo_url || obj.profile_photo_path || obj.profile_photo || null
  );
}
